import { createApp } from 'vue';
import Global from 'vue@/plugin/global'
import VueGoogleMaps from '@fawmi/vue-google-maps';



createApp({
    data() {
        return {
            center: {
                lat: parseFloat(window.eventHeader.locationLat),
                lng: parseFloat(window.eventHeader.locationLong)
            },
            zoom: 4,
            mapOptions: {
                fullscreenControl: false,
                streetViewControl: false,
                mapTypeControl: false,
            },
            markers: [
                {
                    id: 1,
                    position: {
                        lat: parseFloat(window.eventHeader.locationLat),
                        lng: parseFloat(window.eventHeader.locationLong),
                    }
                }
            ],
            mapType: 'roadmap',
        }
    },
})
    .use(VueGoogleMaps, {
        load: {
            key: window.googleMapsApiKey,
            libraries: 'places,geometry',
        },
        installComponents: true,
    })
    .use(Global)
    .mount('#eventHeader');
